import { baseThemeValues } from 'constants/common';

const descriptionFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 400,
};

const subSectionLabelFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 600,
};

export const bulkCopyTheme = {
  description: {
    ...descriptionFont,
    text: 'palette.tertiary.60',
  },
  separator: 'palette.tertiary.30',
  subSection: {
    label: {
      ...subSectionLabelFont,
      text: 'palette.tertiary.95',
    },
  },
};
